var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-xl flex flex-col flex-1 flex-wrap pb-10 mt-10 md:mt-16 h-full px-6 md:px-14 w-full"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }